<template>
  <b-row class="admin-customers-row mx-0 mt-5">
    <b-col
      md="12"
      xl="12"
      lg="12"
      :style="{padding: '1.25rem'}"
      class="handover-card-column d-flex"
    >
      <b-col cols="3" class="">
        <h6 class="font-sm primary--text font-family-medium">Customer name</h6>
      </b-col>
      <b-col cols="2" class="">
        <h6 class="font-sm primary--text font-family-medium">
          Company Name
        </h6>
      </b-col>
      <b-col cols="2" class="">
        <h6 class="font-sm primary--text font-family-medium">Subscription Type</h6>
      </b-col>
      <b-col cols="2" class="">
        <h6 class="font-sm primary--text font-family-medium">
          Profile type
        </h6>
      </b-col>
      <b-col  class="" cols="2">
        <h6 class="font-sm primary--text font-family-medium">Date</h6>
      </b-col>
      <b-col class="d-flex justify-space-evenly" cols="1">
        <h6 class="font-sm primary--text font-family-medium">Actions</h6>
      </b-col>
    </b-col>
    <div class="w-100">
      <b-col
        v-for="item in unassignedCustomersList"
        :key="item.id"
        md="12"
        xl="12"
        lg="12"
        class="px-0 py-2 handover-card-column"
      >
        <b-card
          no-body
          @click="navigate(item)"
          @mouseenter="showCardHover(item.id)"
          @mouseleave="undoCardHover(item.id)"
        >
          <b-card-body class="py-4 d-flex align-items-center">
            <b-col cols="3" class="d-flex align-items-center">
              <b-avatar
                v-if="item.user.avatarThumbnail"
                size="4.4rem"
                :src="item.user.avatarThumbnail"
              ></b-avatar>
              <b-avatar
                class="customer-avatar bg--primary"
                v-else
                size="4.4rem"
                :text="userInitials(item.user)"
              ></b-avatar>
              <h6 :title="`${item.user.firstName} ${item.user.lastName}`"
                class="font-sm font-family-medium primary--text reduce-line-height pl-3"
              >
                {{ ellipsify(`${item.user.firstName} ${item.user.lastName}`, 30) }}
              </h6>
            </b-col>
            <!-- <b-button class="btn-danger btn-pill notification-btn-grid ml-5"
            >New</b-button
          > -->

            <b-col cols="2" class="">
              <h6
                class="font-sm primary--text font-weight-normal"
              >
                {{ getCompanyName(item) }}
              </h6>
            </b-col>
            <b-col cols="2" class="">
              <h6
                class="font-sm primary--text font-weight-normal reduce-line-height text-capitalize"
              >
                {{ getCompanyMembership(item) }}
              </h6>
            </b-col>
            <b-col cols="2"
              class="d-flex align-items-center "
            >
              <h6
                class="font-sm primary--text font-weight-normal"
                v-for="profile in item.customerProfile.profileType
                  .selectedProfileTypes"
                :key="profile.id"
              >
                {{ profile.value }}
              </h6>
            </b-col>
            <b-col cols="2" class="d-flex">
              <h6 class="font-sm primary--text">
                {{ getCreatedAt(item) }}
              </h6>
            </b-col>
            <b-col class="d-flex justify-space-evenly" cols="1">
              <div
                @click.stop="showArchiveModal(item)"
                v-if="
                  !archiveHover ||
                    (showInactiveArchiveHover &&
                      activeArchiveHoverId !== item.id)
                "
                class="empty-icon-avatar d-flex align-items-center justify-content-center"
              >
                <img
                  class="cursor-pointer"
                  src="@/assets/icons/arrow_down_square.svg"
                  alt
                />
              </div>
              <div
                @click.stop="showArchiveModal(item)"
                class="archive-hover-avatar position-relative d-flex align-items-center justify-content-center"
                v-if="archiveHover && activeArchiveHoverId === item.id"
              >
                <img src="@/assets/icons/arrow_down_square_hover.svg" alt="" />
              </div>
            </b-col>
          </b-card-body>
        </b-card>
      </b-col>
      <infinite-loading
        spinner="spiral"
        :identifier="unassignedCustomersId"
        @infinite="infiniteHandlerUnassignedCustomer"
        ><div slot="no-more">
          <h4 class="font-md primary--text font-family-medium mt-5 mb-5">
            No more customers to load.
          </h4>
        </div>
        <div slot="no-results">
          <h4 class="font-md primary--text font-family-medium mt-5 mb-5">
            No more customers to load.
          </h4>
        </div></infinite-loading
      >
    </div>
    <b-modal
      centered
      class="modal-padding"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      v-model="showArchive"
      v-if="showArchive"
    >
      <b-container fluid>
        <b-button
          @click="closeModal"
          class="d-flex position-absolute close-btn"
        >
          <img class="close-icon" src="@/assets/icons/close_sidebar.svg" alt />
        </b-button>
        <b-row class="pt-2 pl-4 d-flex flex-column">
          <h2 v-if="isCustomerArchived" class="font-md modal_header ml-2">
            Successfully archived
          </h2>
          <h4 v-if="!isCustomerArchived" class="font-md subtext mb-4 mt-3 ml-2">
            Do you want to archive the following profile?
          </h4>
          <h4 v-else class="font-md subtext mb-4 mt-1 ml-2">
            Following customer has been successfully archived.
          </h4>
        </b-row>
        <b-row align-v="center">
          <b-col md="9" class="flex-row d-flex mb-4">
            <div>
              <b-avatar
                v-if="selectedCustomerAvatar"
                :src="selectedCustomerAvatar"
                size="8rem"
                class="pa-avatar bg--primary"
              ></b-avatar>
              <b-avatar
                v-else
                :text="selectedCustomerInitials"
                size="8rem"
                class="pa-avatar bg--primary"
              ></b-avatar>
            </div>
            <div
              class="d-flex flex-column justify-content-center position-relative ml-4"
            >
              <p class="font-family-medium primary--text mt-2">
                {{ selectedCustomerFullName }}
              </p>
            </div>
          </b-col>
          <div v-b-tooltip.hover title="Please update End Date to enable archive.">
            <b-button
              @click="archiveCustomer"
              disabled
              v-if="!isCustomerArchived"
              class="btn-primary px-5 py-3 btn-pill ml-2 reduce-whitespace"
            >
              <b-spinner
                v-if="isSavingArchive"
                style="width: 14px; height: 14px"
                variant="light"
                label="Spinning"
              ></b-spinner>
              {{ `${isSavingArchive ? "" : archiveBtnText}` }}
            </b-button>
          </div>
        </b-row>
        <b-row v-if="archiveError" class="archive-error">
          <b-col>
            {{ archiveError }}
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </b-row>
</template>

<script>
import moment from "moment";
import {
  archiveOrDeleteAccount,
  getUnassignedCustomers
} from "@/apis/customers";
import { ellipsify } from "@/utils/utils";
export default {
  name: "UnassignedCustomers",
  props: [
    "filteredCustomerId",
    "selectedSubscriptionId",
    "selectedCompanyId"
  ],
  mounted() {
    this.changeType();
  },
  data() {
    return {
      expandHover: false,
      selectedCustomer: null,
      archiveError: null,
      archiveHover: false,
      deleteHover: false,
      unassignedCustomersList: [],
      activeExpandHoverId: "",
      inactiveExpandHoverId: "",
      showInactiveExpandHover: true,
      activeArchiveHoverId: "",
      inactiveArchiveHoverId: "",
      showInactiveArchiveHover: true,
      activeDeleteHoverId: "",
      inactiveDeleteHoverId: "",
      showInactiveDeleteHover: true,
      showArchive: false,
      selectedCustomerFullName: "",
      selectedCustomerEmail: "",
      selectedCustomerAvatar: "",
      selectedCustomerInitials: "",
      isSavingArchive: false,
      isCustomerArchived: false,
      archiveBtnText: "Archive",
      isDelete: null,
      unassignedCustomersId: +new Date(),
      offsetUnassignedCustomer: 0
    };
  },
  methods: {
    ellipsify,
    getCompanyMembership(customer){
      return customer.customerProfile.membership
        ? customer.customerProfile.membership.title
        : "N/A";
    },
    getCompanyName(customer) {
      return customer.customerProfile.company
        ? customer.customerProfile.company.name
        : "N/A";
    },
    getCreatedAt(customer) {
      return customer.customerProfile.created
        ? this.getFormattedDate(customer.customerProfile.created)
        : "N/A";
    },
    changeType() {
      this.unassignedCustomersList = [];
      this.offsetUnassignedCustomer = 0;
      this.unassignedCustomersId += 1;
    },
    infiniteHandlerUnassignedCustomer($state) {
      let data = {
        membership: this.selectedSubscriptionId,
        id: this.filteredCustomerId,
        company: this.selectedCompanyId
      };
      getUnassignedCustomers(30, this.offsetUnassignedCustomer, data).then(
        res => {
          this.unassignedCustomersList = [
            ...this.unassignedCustomersList,
            ...res.data.results
          ];
          this.offsetUnassignedCustomer = res.data.offset;
          if (res.data.next === null) {
            $state.complete();
          } else {
            $state.loaded();
          }
        }
      );
    },
    navigate(item) {
      if (!item.isOnboardingIntakeSubmitted) {
        this.$router.push({
          name: "CustomerIntake",
          params: {
            pid: item.id
          }
        });
      } else {
        this.$router.push({
          name: "AssignPAtoCustomer",
          params: {
            id: item.id
          }
        });
      }
    },
    userInitials(user) {
      let initials = `${user.firstName.split(" ")[0]} ${user.lastName}`;
      return initials.match(/\b(\w)/g).join("");
    },
    getFormattedDate(date) {
      return moment(date).format("MM/DD/YYYY");
    },
    showArchiveModal(profile) {
      let { user } = profile;
      this.selectedCustomer = profile;
      this.selectedCustomerFullName = `${user.firstName} ${user.lastName}`;
      this.selectedCustomerInitials = this.selectedCustomerFullName
        .match(/\b(\w)/g)
        .join("");
      this.showArchive = true;
      this.selectedCustomerEmail = user.email;
      this.selectedCustomerAvatar = user.avatarThumbnail;
    },
    archiveCustomer() {
      this.isSavingArchive = true;
      const data = {
        profile: this.activeArchiveHoverId,
        isDelete: false
      };
      archiveOrDeleteAccount(data)
        .then(() => {
          this.isSavingArchive = false;
          this.isCustomerArchived = true;
          this.unassignedCustomersList = this.unassignedCustomersList.filter(
            item => item != this.selectedCustomer
          );
        })
        .catch(err => {
          this.archiveError = err.response.data.detail
          this.isSavingArchive = false;
        });
    },
    closeModal() {
      this.showArchive = false;
      this.archiveError = null
      this.isCustomerArchived = false;
    },
    showCardHover(id) {
      this.activeExpandHoverId = id;
      this.expandHover = true;
      this.showInactiveExpandHover = true;
      this.activeArchiveHoverId = id;
      this.archiveHover = true;
      this.showInactiveArchiveHover = true;
      this.activeDeleteHoverId = id;
      this.deleteHover = true;
      this.showInactiveDeleteHover = true;
    },
    undoCardHover(id) {
      this.inactiveExpandHoverId = id;
      this.expandHover = false;
      this.inactiveArchiveHoverId = id;
      this.archiveHover = false;
      this.inactiveDeleteHoverId = id;
      this.deleteHover = false;
    }
  }
};
</script>

<style scoped lang="scss">
.relative-right {
  right: 0.3rem;
}
.date-header {
  right: 3.5rem;
}
.relative-top {
  top: 0.3rem;
}
.actions-header {
}
button.btn.close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none;
}
.card {
  cursor: pointer;
}
</style>
